/* eslint-disable camelcase */

const DesksSignsOfLife = ({ databoxes: { percent_avg_signs_of_life_peek_hour } }) =>
  `During the survey period on average we recorded signs of life at ${percent_avg_signs_of_life_peek_hour}%
   if lunch hours are excluded.`;

export default DesksSignsOfLife;
